import React from 'react';
import { Box, Burger, Group } from '@mantine/core';
import { useIsCompact, useIsPhone, useIsTouch } from '@/hooks/use.responsive';
import ShellLogo from './Shell.Logo';
import ShellNotifications from './Shell.Notifications';
import ShellSearchTrigger from './Shell.Search.Trigger';
import ShellThemeToggle from './Shell.Theme.Toggle';

type Props = {
    mobileOpened: boolean;
    onMobileToggle: () => void;
};

const ShellHeader: React.FC<Props> = ({ mobileOpened, onMobileToggle }) => {
    const isPhone = useIsPhone();
    const isCompact = useIsCompact();
    const isTouch = useIsTouch();

    return (
        <Box
            h="100%"
            px="md"
            style={{
                display: 'grid',
                gridTemplateColumns: isCompact ? 'auto 1fr auto' : '1fr minmax(0, 36rem) 1fr',
                alignItems: 'center',
                columnGap: 'var(--mantine-spacing-md)',
                paddingLeft: 'max(var(--mantine-spacing-md), env(safe-area-inset-left, 0px))',
                paddingRight: 'max(var(--mantine-spacing-md), env(safe-area-inset-right, 0px))',
            }}
        >
            <Group gap="sm" wrap="nowrap" style={{ minWidth: 0 }}>
                <Burger
                    opened={mobileOpened}
                    onClick={onMobileToggle}
                    hiddenFrom="md"
                    size={isTouch ? 'md' : 'sm'}
                    aria-label={mobileOpened ? 'Chiudi il menù di navigazione' : 'Apri il menù di navigazione'}
                />
                <ShellLogo compact={isPhone} />
            </Group>

            <Box style={{ display: 'flex', justifyContent: 'center', minWidth: 0 }}>
                {isPhone ? null : <ShellSearchTrigger />}
            </Box>

            <Group gap="xs" wrap="nowrap" justify="flex-end">
                {isPhone ? <ShellSearchTrigger iconOnly /> : null}
                <ShellThemeToggle />
                <ShellNotifications />
            </Group>
        </Box>
    );
};

export default ShellHeader;
